import React from 'react';
import './tailwind.min.css';
import './App.css';

const green: string = '\u001b[32m';
console.log(`Hy! I'm kai and ${green} happy to see you :)`);

export default function App( ) {
  return (
    <div className="mx-5">
      {/*<Header />*/}
      {/*<Footer />*/}
    </div>

  );
}

